/**********************************************************************
 *
 * Copyright (C) 2022 Almendo Technologies GmbH
 * Copyright (C) 2022 Marcus Harringer
 *
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of
 * Marcus Harringer. The intellectual and technical concepts contained
 * herein are proprietary to Marcus Harringer and may be covered
 * copyright law. Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written permission
 * is obtained from Marcus Harringer.
 *
 ***********************************************************************/
// Single access point for .env.local and the backend config - consumers import from here,
// nothing else reads process.env.

// Active environment (validated in getEnvironment.js)
export const blusensorEnv = process.env.REACT_APP_BLUSENSOR_ENV || null;

// Committed backend config per environment (src/env/backend.<env>.json, same files in Android and iOS).
// The path contains REACT_APP_BLUSENSOR_ENV directly so the build bundles only the selected file.
const loadBackend = () => {
  try {
    const backend = require(`./env/backend.${process.env.REACT_APP_BLUSENSOR_ENV}.json`);
    return backend.BLUSENSOR_ENV === blusensorEnv ? backend : {};
  } catch (err) {
    return {};
  }
};

const backend = loadBackend();

// AWS region of the CDK resources (cognito, api, storage, location)
export const awsRegion = backend.AWS_REGION || null;

// CDK backend: Cognito, GraphQL API and user storage, required (enforced in aws-exports-app.js)
export const appsyncConfig = {
  graphqlEndpoint: backend.AWS_APPSYNC_GRAPHQL_ENDPOINT || null,
  defaultAuthMode: 'userPool'
};

export const storageConfig = {
  region: awsRegion,
  userFilesBucket: backend.AWS_USER_STORAGE_BUCKET || null
};

export const cognitoConfig = {
  userPoolId: backend.AWS_USER_POOLS_ID || null,
  userPoolWebClientId: backend.AWS_USER_POOLS_CLIENT_ID || null,
  identityPoolId: backend.AWS_COGNITO_IDENTITY_POOL_ID || null
};

// Sign-in with an identity provider through the Cognito hosted UI, off without AWS_COGNITO_LOGIN_DOMAIN.
// Company accounts are found by Cognito from the mail domain (the public API answers whether a domain has one).
export const ssoConfig = {
  loginDomain: backend.AWS_COGNITO_LOGIN_DOMAIN || null,
  publicApiUrl: backend.AWS_PUBLIC_API_URL || null
};

// Amazon Location: map tiles + geocoding of the facility address when no GPS is set.
// Empty key = no map, geocoding off.
export const locationConfig = {
  region: awsRegion,
  mapStyle: 'Standard',
  apiKey: process.env.REACT_APP_AWS_LOCATION_API_KEY || null
};

export const reduxConfig = {
  devTools: process.env.REACT_APP_ENABLE_REDUX_DEV_TOOLS === 'true'
};
